<template>
  <!--
  <v-btn rounded block dark color="#4267b2" @click="logInWithFacebook" :loading="loading">
    <v-icon left>fab fa-facebook-f</v-icon>Login with facebook
  </v-btn>
  -->
  <button class="fbBtn" @click="logInWithFacebook" :loading="loading">
    <!--
      <v-icon left>fab fa-google</v-icon>
    -->
    <v-icon>mdi-facebook</v-icon>
    Continuer avec Facebook
  </button>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "facebookLogin",
  computed: {
    ...mapGetters({ loading: "loading" }),
  },
  created() {
    this.loadFacebookSDK(document, "script", "facebook-jssdk");
    this.initFacebook();
  },
  methods: {
    ...mapActions(["signUserInFacebookPassport"]),
    async logInWithFacebook() {
      window.FB.login(
        (response) => {
          if (response.authResponse) {
            this.signUserInFacebookPassport({
              accessToken: response.authResponse.accessToken,
            });
            return response;
          } else {
          }
        },
        { scope: "public_profile,email" }
      );
      return false;
    },
    async logOutWithFacebook() {
      await window.FB.logout((response) => {
        console.log("logged out");
      });
    },
    async initFacebook() {
      window.fbAsyncInit = () => {
        window.FB.init({
          appId: process.env.VUE_APP_FB_ID,
          cookie: true,
          version: "v13.0",
        });
      };
    },
    async loadFacebookSDK(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    },
    loadingBotton() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 50000);
    },
  },
};
</script>

<style scoped>
.fbBtn {
  border: 2px solid #4960bb;
  padding: 7px 0;
  width: 300px;
  border-radius: 50px;
  color: #4960bb;
  font-size: 17px;
  font-weight: bold;
  margin: 0 auto;
  line-height: 1.3;
  display: block;
  transition: all 0.3s ease-in-out;
}
.fbBtn .v-icon {
  font-size: 33px;
  color: #4960bb;
  margin-right: 25px;
  display: inline-flex;
}
.fbBtn:hover {
  border: 2px solid #4960bb;
  color: #fff;
  background: #4960bb;
}
.fbBtn:hover .v-icon {
  color: #fff;
}
</style>